;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import Text from 'components/ui/Text';

import styles from './FilterCheckbox.module.scss';

const FilterBodyCheckbox = ({ label, checked, onChange }) => {
    return (
        <div className={styles.root}>
            <Text baseTheme="bodySmall" className={styles.checkbox}>
                <label className={styles.label}>
                    <span className={styles.checkmarkWrapper}>
                        <input
                            type="checkbox"
                            defaultChecked={checked}
                            onChange={onChange}
                            className={styles.input}
                        />
                        <span className={styles.checkmark} />
                    </span>
                    <span>{label}</span>
                </label>
            </Text>
        </div>
    );
};

FilterBodyCheckbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};

export default FilterBodyCheckbox;
